module.exports = __webpack_public_path__ + "static/media/Kitchen.bff31c0c.png";